// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"image-card_wrapper__MlXho"};